import prependHttp from 'prepend-http';
import { getMailRegex, getUrlRegex } from '@common/constants/regexes';

export default {
  isUrl(text: string): boolean {
    return getUrlRegex().test(text);
  },

  isMail(text: string): boolean {
    return getMailRegex().test(text);
  },

  normaliseMail(email: string): string {
    if (email.toLowerCase().startsWith('mailto:')) {
      return email;
    }
    return `mailto:${email}`;
  },

  normalizeUrl(url: string): string {
    return prependHttp(url);
  },
};
